import "vant/es/toast/style";
import _Toast from "vant/es/toast";
export default {
  data: function data() {
    return {
      indexList: [],
      schoolList: [],
      schoolVal: "",
      schoolName: "",
      schoolNameVal: "",
      activeVal: "",
      isLoading: false
    };
  },
  props: {
    enterType: {
      type: String,
      default: ""
    },
    typeof: {
      type: String,
      default: ""
    }
  },
  created: function created() {
    this.GetSchoolListByWord();
  },
  methods: {
    backBtn: function backBtn() {
      this.$router.go(-1);
    },
    appSchool: function appSchool() {
      this.$router.push({
        name: "schoolApply",
        params: {
          enterType: this.enterType,
          typeof: this.typeof
        }
      });
    },
    selectSchool: function selectSchool(id, name) {
      this.schoolVal = id;
      this.activeVal = id;
      this.schoolName = name;
    },
    searchBtn: function searchBtn() {
      this.GetSchoolListByWord();
    },
    GetSchoolListByWord: function GetSchoolListByWord() {
      var _this = this;

      this.isLoading = true;
      this.$http.post("/api/XOrg/XLogin/GetAllSchoolList", {
        SchoolName: this.schoolNameVal
      }).then(function (res) {
        if (res.code > 0) {
          _this.isLoading = false;
          _this.indexList = res.charArray;
          _this.schoolList = res.schoollist;
        } else {
          return;
        }
      });
    },
    sureSelect: function sureSelect() {
      if (this.schoolVal == "") {
        return _Toast({
          message: "请选择学校",
          type: "fail"
        });
      }

      if (this.enterType == 'login') {
        this.$router.push({
          name: 'phLogin',
          params: {
            schoolId: this.schoolVal,
            schoolName: this.schoolName
          }
        });
      }

      if (this.enterType == 'register') {
        this.$router.push({
          name: 'phRegister',
          params: {
            schoolId: this.schoolVal,
            schoolName: this.schoolName,
            typeof: this.typeof
          }
        });
      }
    }
  }
};